import React, { useEffect, useRef, useState } from 'react'; 
import { getTimeAgo } from 'services/posts-service';

type Props = {
  position:string;
  post:any; 
  type?:string;
  className?:string;
  onNewError:Function; 
};

const ActiveVotesButton = ({position,post, type = "button", onNewError,className }: Props) => {
  const [open, setOpen] = useState(false); 
  const menuRef = useRef<HTMLDivElement | null>(null); 
  useEffect(() => {
    try {
        const handleClickOutside = (event) => {
        const menuNode = menuRef.current;
        if (menuNode && !menuNode.contains(event.target)) {
            setOpen(false);
        }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    } catch (error) {
        onNewError(error)
    }
    
  }, []);
  function getActiveVotes (post_data:any) {
    let active_votes = post_data.active_votes;
    if (post_data.net_votes > 0 && post_data.active_votes_modified) { 
      active_votes = post_data.active_votes_modified;
    }
    return active_votes;
  } 
  let votes = 0;
  let active_votes = [];
  if (post && post.active_votes) { 
    let votes_counter = 0; 
    active_votes = getActiveVotes(post);
    for (let i = 0; i < active_votes.length; i++) {
      const voter = active_votes[i];  
      if (voter.percent > 0) {
        votes_counter++; 
      }
    }
    votes = votes_counter; 
  } 
  

  return (
    <div ref={menuRef} className="relative d-inline-block">
      {type == "inline" && (
        <a className={`no-color ${className || ""}`} style={{cursor:"pointer"}} onClick={() => { setOpen(!open);}}>
          {votes} <i className="fas fa-caret-down" />
        </a> 
      )}
      {type == "button" && (
        <button className={`btn post-tools  ${className || ""}`} onClick={() => { setOpen(!open);}}>
          <i className="fas fa-caret-down" />
        </button> 
      )}
      
      {open && (
        <div className={"absolute text-left overflow-y dropdown-window " + position}>
          <p className="w-100 mb-1">Voters</p>
          {votes > 0 &&
            [...active_votes]
              .sort((a, b) => Math.abs(b.rshares) - Math.abs(a.rshares)) 
              .map((v) => (
                <div key={v.voter+v.time} className="vote-item" style={{fontSize:"0.7rem"}}> 
                  <span>
                    <i className={"fas fa-heart "+ (v.percent >= 0? "color-green":"color-red")} /> <b><a href={`/u/${v.voter}`} className='no-color'>{v.voter}</a></b>
                  </span> <span>({(v.percent / 100).toFixed(1)}%)</span> · <span>{getTimeAgo(v.time)}</span>
                </div>
          ))}
          {votes <= 0 && (
            <p className='w-100 text-muted'>No voters yet</p>
          )}
        </div>
      )}

      
    </div>
    
  );
};

export default ActiveVotesButton;
